import { render, staticRenderFns } from "./MsgTemplateList.vue?vue&type=template&id=2684cd20&scoped=true&"
import script from "./MsgTemplateList.vue?vue&type=script&lang=js&"
export * from "./MsgTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./MsgTemplateList.vue?vue&type=style&index=0&id=2684cd20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684cd20",
  null
  
)

export default component.exports